import React from "react";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import banner from "../../assets/Services/banner.png";
import CountUp from "react-countup";
import wcslogo from "../../assets/Services/wcs-logo.png";

import wcs1 from "../../assets/Services/wcs1.png";
import wcs2 from "../../assets/Services/wcs2.png";
import wcs3 from "../../assets/Services/wcs3.png";
import wcs4 from "../../assets/Services/wcs4.png";
import BlueRightArrow from "../../assets/Contactus/blue-right-arrow.png";

import engineering1 from "../../assets/Services/engineering1.png";

import Rectangle from "../../assets/Services/Rectangle.jpg";

import industry1 from "../../assets/Services/industry1.png";
import industry2 from "../../assets/Services/industry2.png";
import industry3 from "../../assets/Services/industry3.png";
import industry4 from "../../assets/Services/industry4.png";
import industry5 from "../../assets/Services/industry5.png";

import equipment1 from "../../assets/Services/equipment1.png";
import equipment2 from "../../assets/Services/equipment2.png";
import equipment3 from "../../assets/Services/equipment3.png";
import equipment4 from "../../assets/Services/equipment4.png";
import equipment5 from "../../assets/Services/equipment5.png";
import equipment6 from "../../assets/Services/equipment6.png";
import equipment7 from "../../assets/Services/equipment7.png";
import equipment8 from "../../assets/Services/equipment8.png";

import EngineeringDesign from "../../assets/Services/Engineering & Design-1.png";
import EPCProjectManagement from "../../assets/Services/EPC & Project Management.jpg";
import CivilStructuralWorks from "../../assets/Services/Civil & Structural Works.jpg";
import MechanicalPipingWorks from "../../assets/Services/Mechanical & Piping Works.jpg";
import ElectricalInstrumentation from "../../assets/Services/Electrical & Instrumentation.jpg";
import TelecomSecuritySystems from "../../assets/Services/Telecom & Security Systems.jpg";

import "./Services.css";

const Servies = () => {
  // const [hover, setHover] = useState(false);
  // const [hoverService2, setHoverService2] = useState(false);
  // const [hoverService3, setHoverService3] = useState(false);
  // const [hoverService4, setHoverService4] = useState(false);
  // const [hoverService5, setHoverService5] = useState(false);
  // const [hoverService6, setHoverService6] = useState(false);

  // const onHover = (e) => {
  //   e.preventDefault();
  //   setHover(true);
  // };

  // const onHoverOver = (e) => {
  //   e.preventDefault();
  //   setHover(false);
  // };

  // const onHoverService2 = (e) => {
  //   e.preventDefault();
  //   setHoverService2(true);
  // };

  // const onHoverOverService2 = (e) => {
  //   e.preventDefault();
  //   setHoverService2(false);
  // };

  // const onHoverService3 = (e) => {
  //   e.preventDefault();
  //   setHoverService3(true);
  // };

  // const onHoverOverService3 = (e) => {
  //   e.preventDefault();
  //   setHoverService3(false);
  // };

  // const onHoverService4 = (e) => {
  //   e.preventDefault();
  //   setHoverService4(true);
  // };

  // const onHoverOverService4 = (e) => {
  //   e.preventDefault();
  //   setHoverService4(false);
  // };

  // const onHoverService5 = (e) => {
  //   e.preventDefault();
  //   setHoverService5(true);
  // };

  // const onHoverOverService5 = (e) => {
  //   e.preventDefault();
  //   setHoverService5(false);
  // };

  // const onHoverService6 = (e) => {
  //   e.preventDefault();
  //   setHoverService6(true);
  // };

  // const onHoverOverService6 = (e) => {
  //   e.preventDefault();
  //   setHoverService6(false);
  // };

  const [hoverId, setHoverId] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const services = [
    {
      id: 1,
      img: EngineeringDesign,
      title: "Engineering & Design",
      description:
        "Innovative engineering solutions with cutting-edge design methodologies for complex industrial projects.",
      points: [
        "Process Engineering",
        "3D Modeling & CAD",
        "Structural Analysis",
        "Safety Engineering",
      ],
    },
    {
      id: 2,
      img: EPCProjectManagement,
      title: "EPC & Project Management",
      description:
        "End-to-end project execution from engineering to procurement and construction management.",
      points: [
        "Turnkey Solutions",
        "Cost Optimization",
        "Timeline Management",
        "Quality Assurance",
      ],
    },
    {
      id: 3,
      img: CivilStructuralWorks,
      title: "Civil & Structural Works",
      description:
        "Robust civil engineering and structural construction services for industrial facilities.",
      points: [
        "Foundation Systems",
        "Steel Structures",
        "Concrete Works",
        "Infrastructure Development",
      ],
    },
    {
      id: 4,
      img: MechanicalPipingWorks,
      title: "Mechanical & Piping Works",
      description:
        "Precision mechanical installations and complex piping systems for industrial applications.",
      points: [
        "Equipment Installation",
        "Piping Systems",
        "HVAC Solutions",
        "Maintenance Services",
      ],
    },
    {
      id: 5,
      img: ElectricalInstrumentation,
      title: "Electrical & Instrumentation",
      description:
        "Advanced electrical systems and precision instrumentation for industrial automation.",
      points: [
        "Power Distribution",
        "Control Systems",
        "Automation Solutions",
        "Safety Systems",
      ],
    },
    {
      id: 6,
      img: TelecomSecuritySystems,
      title: "Telecom & Security Systems",
      description:
        "Comprehensive telecommunications and security infrastructure for modern facilities.",
      points: [
        "Network Infrastructure",
        "CCTV Systems",
        "Access Control",
        "Fire Safety Systems",
      ],
    },
  ];

  const handleClick = (id) => {
    if (isMobile) {
      setHoverId(hoverId === id ? null : id); // toggle on mobile
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* <div className="image-container">
        <img src={banner} className="home1" alt="Home" />
        <div className="overlay"></div> 
        <div className="overlay-text-container overlay-text-container-services">
          <h5>
            Comprehensive <br />
            Engineering & Construction <br />
            Services
          </h5>
          <p style={{ fontSize: "20px" }}>
            Delivering innovative, safe, and sustainable solutions across Oil &
            <br />
            Gas, Infrastructure, Power, and Water industries. &{" "}
          </p>

          <Link to="/projects" className="explore-projects-btn">
            Explore Projects
          </Link>
        </div>
      </div> */}

      <div className="services-us-image-container">
        <div className="overlay-text-container-services">
          <h1 className="services-main-heading">
            Comprehensive <br />
            Engineering & Construction <br />
            Services
          </h1>
          <p className="services-main-description">
            Delivering innovative, safe, and sustainable solutions across Oil &
            <br />
            Gas, Infrastructure, Power, and Water industries.{" "}
          </p>
          <Link
            to="/projects"
            onClick={scrollToTop}
            className="explore-projects-btn"
          >
            Explore Projects
          </Link>
        </div>
      </div>

      <div className="our-services-container">
        <h1>Our Services</h1>
        <p>
          Comprehensive engineering and construction solutions tailored to meet
          the diverse needs of modern industries.
        </p>
        {/* <Row style={{ width: "99%" }}>
          <Col md={3}>
            <div
              className="services-image-container"
              onMouseEnter={onHover}
              onMouseLeave={onHoverOver}
            >
              <img
                src={EngineeringDesign}
                alt="EngineeringDesign"
                className="services-project-image"
              />

              {hover ? (
                <div className="service-card hoverData">
                  <img src={wcslogo} className="service-logo" />
                  <h1 className="service-card-title">Engineering & Design</h1>
                  <p className="service-card-description">
                    Innovative engineering solutions with cutting-edge design
                    methodologies for complex industrial projects.
                  </p>
                  <ul className="service-card-points">
                    <li className="point">Process Engineering</li>
                    <li className="point">3D Modeling & CAD</li>
                    <li className="point">Structural Analysis</li>
                    <li className="point">Safety Engineering</li>
                  </ul>
                </div>
              ) : (
                <h1 className="services-heading">Engineering & Design</h1>
              )}
            </div>
          </Col>

          <Col md={3}>
            <div
              className="services-image-container"
              onMouseEnter={onHoverService2}
              onMouseLeave={onHoverOverService2}
            >
              <img
                src={EPCProjectManagement}
                alt="EngineeringDesign"
                className="services-project-image"
              />

              {hoverService2 ? (
                <div className="service-card hoverData">
                  <img src={wcslogo} className="service-logo" />
                  <h1 className="service-card-title">
                    EPC & Project Management
                  </h1>
                  <p className="service-card-description">
                    End-to-end project execution from engineering to procurement
                    and construction management.
                  </p>
                  <ul className="service-card-points">
                    <li className="point">Turnkey Solutions</li>
                    <li className="point">Cost Optimization</li>
                    <li className="point">Timeline Management</li>
                    <li className="point">Quality Assurance</li>
                  </ul>
                </div>
              ) : (
                <h1 className="services-heading">EPC & Project Management</h1>
              )}
            </div>
          </Col>

          <Col md={3}>
            <div
              className="services-image-container"
              onMouseEnter={onHoverService3}
              onMouseLeave={onHoverOverService3}
            >
              <img
                src={CivilStructuralWorks}
                alt="EngineeringDesign"
                className="services-project-image"
              />

              {hoverService3 ? (
                <div className="service-card hoverData">
                  <img src={wcslogo} className="service-logo" />
                  <h1 className="service-card-title">
                    Civil & Structural Works
                  </h1>
                  <p className="service-card-description">
                    Robust civil engineering and structural construction
                    services for industrial facilities.
                  </p>
                  <ul className="service-card-points">
                    <li className="point">Foundation Systems</li>
                    <li className="point">Steel Structures</li>
                    <li className="point">Concrete Works</li>
                    <li className="point">Infrastructure Development</li>
                  </ul>
                </div>
              ) : (
                <h1 className="services-heading">Civil & Structural Works</h1>
              )}
            </div>
          </Col>

          <Col md={3}>
            <div
              className="services-image-container"
              onMouseEnter={onHoverService4}
              onMouseLeave={onHoverOverService4}
            >
              <img
                src={MechanicalPipingWorks}
                alt="EngineeringDesign"
                className="services-project-image"
              />

              {hoverService4 ? (
                <div className="service-card hoverData">
                  <img src={wcslogo} className="service-logo" />
                  <h1 className="service-card-title">
                    Mechanical & Piping Works
                  </h1>
                  <p className="service-card-description">
                    Precision mechanical installations and complex piping
                    systems for industrial applications.
                  </p>
                  <ul className="service-card-points">
                    <li className="point">Equipment Installation</li>
                    <li className="point">Piping Systems</li>
                    <li className="point">HVAC Solutions</li>
                    <li className="point">Maintenance Services</li>
                  </ul>
                </div>
              ) : (
                <h1 className="services-heading">Mechanical & Piping Works</h1>
              )}
            </div>
          </Col>
        </Row>

        <Row style={{ width: "99%" }}>
          <Col md={3}>
            <div
              className="services-image-container"
              onMouseEnter={onHoverService5}
              onMouseLeave={onHoverOverService5}
            >
              <img
                src={ElectricalInstrumentation}
                alt="EngineeringDesign"
                className="services-project-image"
              />

              {hoverService5 ? (
                <div className="service-card hoverData">
                  <img src={wcslogo} className="service-logo" />
                  <h1 className="service-card-title">
                    Electrical & Instrumentation
                  </h1>
                  <p className="service-card-description">
                    Advanced electrical systems and precision instrumentation
                    for industrial automation.
                  </p>
                  <ul className="service-card-points">
                    <li className="point">Power Distribution</li>
                    <li className="point">Control Systems</li>
                    <li className="point">Automation Solutions</li>
                    <li className="point">Safety Systems</li>
                  </ul>
                </div>
              ) : (
                <h1 className="services-heading">
                  Electrical & Instrumentation
                </h1>
              )}
            </div>
          </Col>

          <Col md={3}>
            <div
              className="services-image-container"
              onMouseEnter={onHoverService6}
              onMouseLeave={onHoverOverService6}
            >
              <img
                src={TelecomSecuritySystems}
                alt="EngineeringDesign"
                className="services-project-image"
              />

              {hoverService6 ? (
                <div className="service-card hoverData">
                  <img src={wcslogo} className="service-logo" />
                  <h1 className="service-card-title">
                    Telecom & Security Systems
                  </h1>
                  <p className="service-card-description">
                    Comprehensive telecommunications and security infrastructure
                    for modern facilities.
                  </p>
                  <ul className="service-card-points">
                    <li className="point">Network Infrastructure</li>
                    <li className="point">CCTV Systems</li>
                    <li className="point">Access Control</li>
                    <li className="point">Fire Safety Systems</li>
                  </ul>
                </div>
              ) : (
                <h1 className="services-heading">Telecom & Security Systems</h1>
              )}
            </div>
          </Col>

          <Col md={3}>
            <div className="service-img-card">
              <h1 className="service-construction-heading">
                Engineering & Construction Services
              </h1>
            </div>
          </Col>
        </Row> */}

        <Row style={{ width: "99%" }}>
          {services.slice(0, 4).map((service) => (
            <Col md={3} key={service.id}>
              <div
                className="services-image-container"
                onMouseEnter={
                  !isMobile ? () => setHoverId(service.id) : undefined
                }
                onMouseLeave={!isMobile ? () => setHoverId(null) : undefined}
                onClick={() => handleClick(service.id)}
              >
                <img
                  src={service.img}
                  alt={service.title}
                  className="services-project-image"
                />

                {hoverId === service.id ? (
                  <div className="service-card hoverData">
                    <img src={wcslogo} className="service-logo" alt="logo" />
                    <h1 className="service-card-title">{service.title}</h1>
                    <p className="service-card-description">
                      {service.description}
                    </p>
                    <ul className="service-card-points">
                      {service.points.map((point, i) => (
                        <li key={i} className="point">
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <h1 className="services-heading">{service.title}</h1>
                )}
              </div>
            </Col>
          ))}
        </Row>

        <Row style={{ width: "99%" }}>
          {services.slice(4).map((service) => (
            <Col md={3} key={service.id}>
              <div
                className="services-image-container"
                onMouseEnter={
                  !isMobile ? () => setHoverId(service.id) : undefined
                }
                onMouseLeave={!isMobile ? () => setHoverId(null) : undefined}
                onClick={() => handleClick(service.id)}
              >
                <img
                  src={service.img}
                  alt={service.title}
                  className="services-project-image"
                />

                {hoverId === service.id ? (
                  <div className="service-card hoverData">
                    <img src={wcslogo} className="service-logo" alt="logo" />
                    <h1 className="service-card-title">{service.title}</h1>
                    <p className="service-card-description">
                      {service.description}
                    </p>
                    <ul className="service-card-points">
                      {service.points.map((point, i) => (
                        <li key={i} className="point">
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <h1 className="services-heading">{service.title}</h1>
                )}
              </div>
            </Col>
          ))}

          <Col md={3}>
            <div className="service-img-card">
              <h1 className="service-construction-heading">
                Engineering & Construction Services
              </h1>
            </div>
          </Col>
        </Row>
      </div>

      <div className="why-choose-section">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h1 className="why-choose-section-heading">Why Choose TAUC </h1>
          <div className="why-choose-section-highlights">
            <div className="d-flex flex-column align-items-center m-1">
              <div className="round-wcs">
                <img src={wcs1} />
              </div>
              {/* <p style={{ color: "#111827", margin: 0 }}>20+ Years</p> */}
              <p style={{ color: "#111827", margin: 0 }}>
                <CountUp start={0} end={20} duration={10.5} />+ Years
              </p>
              <p style={{ color: "#4B5563" }}>of Experience</p>
            </div>
            <div className="d-flex flex-column align-items-center">
              <div className="round-wcs">
                <img src={wcs2} />
              </div>
              {/* <p style={{ color: "#111827", margin: 0 }}>60+</p> */}
              <p style={{ color: "#111827", margin: 0 }}>
                <CountUp start={0} end={60} duration={10.5} />+
              </p>
              <p style={{ color: "#4B5563" }}>Skilled Employees</p>
            </div>
            <div className="d-flex flex-column align-items-center">
              <div className="round-wcs">
                <img src={wcs3} />
              </div>
              <p style={{ color: "#111827", margin: 0 }}>ISO Certified</p>
              <p style={{ color: "#4B5563" }}>QHSE Standards</p>
            </div>
            <div className="d-flex flex-column align-items-center">
              <div className="round-wcs">
                <img src={wcs4} />
              </div>
              <p style={{ color: "#111827", margin: 0 }}>Modern</p>
              <p style={{ color: "#4B5563" }}>Equipment Fleet</p>
            </div>
          </div>
        </div>
      </div>

      <div className="engineering-excellence-section">
        <img
          src={engineering1}
          className="engineering-img"
          alt="engineering excellence"
        />
        <div className="engineering-content-container">
          <h1 className="content-heading">Engineering Excellence</h1>
          <p className="content-description">
            Our engineering team combines decades of experience with
            cutting-edge technology to deliver innovative solutions that exceed
            industry standards. We specialize in complex industrial projects
            that require precision, safety, and reliability.
          </p>
          <p className="content-description">
            From initial concept to detailed design, our engineers work closely
            with clients to ensure every project meets specific requirements
            while optimizing for cost-effectiveness and sustainability.
          </p>
          {/* <a>Explore Projects →</a> */}
          <Link
            to="/projects"
            onClick={scrollToTop}
            className="explore-projects-btn"
          >
            <a style={{ textDecoration: "none", color: "black" }}>
              Explore Projects →
            </a>
          </Link>
        </div>
      </div>

      <div className="engineering-excellence-section">
        <div className="engineering-content-container engineering-content-container-order">
          <h1 className="content-heading">Construction Mastery</h1>
          <p className="content-description">
            Our construction capabilities span across multiple industries,
            delivering projects on time and within budget. We utilize modern
            equipment and proven methodologies to ensure the highest quality
            standards.
          </p>
          <p className="content-description">
            Safety is our top priority, with comprehensive QHSE protocols that
            protect our workforce and ensure compliance with international
            standards. Our skilled craftsmen bring expertise to every aspect of
            construction.
          </p>
          {/* <a>Explore Projects →</a> */}
          <Link
            to="/projects"
            onClick={scrollToTop}
            className="explore-projects-btn"
          >
            <a style={{ textDecoration: "none", color: "black" }}>
              Explore Projects →
            </a>
          </Link>
        </div>
        <img src={Rectangle} className="engineering-img" />
      </div>

      <div className="industries-we-serve-section">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h1 className="industries-we-serve-section-heading">
            Industries We Serve
          </h1>
          <p className="industries-we-serve-section-description">
            Delivering specialized solutions across diverse industrial sectors
          </p>
          <div className="industries-we-serve-container">
            <div className="serve-card">
              <div className="round-wcs">
                <img src={industry1} />
              </div>
              <p style={{ color: "#111827", margin: 0 }}>Oil & Gas</p>
            </div>
            <div className="serve-card">
              <div className="round-wcs">
                <img src={industry2} />
              </div>
              <p style={{ color: "#111827", margin: 0 }}>Power & Energy</p>
            </div>
            <div className="serve-card">
              <div className="round-wcs">
                <img src={industry3} />
              </div>
              <p style={{ color: "#111827", margin: 0 }}>Petrochemicals</p>
            </div>
            <div className="serve-card">
              <div className="round-wcs">
                <img src={industry4} />
              </div>
              <p style={{ color: "#111827", margin: 0 }}>Infrastructure</p>
            </div>
            <div className="serve-card">
              <div className="round-wcs">
                <img src={industry5} />
              </div>
              <p style={{ color: "#111827", margin: 0 }}>Water & Wastewater</p>
            </div>
          </div>
        </div>
      </div>

      <div className="equipment-fleet-section">
        <h1 className="industries-we-serve-section-heading">
          Our Equipment Fleet
        </h1>
        <div className="d-flex justfiy-content-center align-items-center">
          <Row style={{ margin: "20px", width: "99%" }}>
            <Col md={3}>
              <div className="equipment-card">
                <div className="round-1">
                  <img src={equipment1} />
                </div>
                <h1 className="service-card-title">Excavators</h1>
                <p
                  className="service-card-description"
                  style={{ color: "#2563EB" }}
                >
                  <CountUp
                    start={0}
                    end={11}
                    duration={10.5}
                    className="count-service"
                  />
                </p>
                <p className="service-card-description">
                  {" "}
                  Heavy-duty excavation equipment
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="equipment-card">
                <div className="round-2">
                  <img src={equipment2} />
                </div>
                <h1 className="service-card-title">Dump Trucks</h1>
                <p
                  className="service-card-description"
                  style={{ color: "#9333EA" }}
                >
                  <CountUp
                    start={0}
                    end={8}
                    duration={10.5}
                    className="count-service"
                  />
                </p>
                <p className="service-card-description">
                  {" "}
                  Material transportation vehicles
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="equipment-card">
                <div className="round-3">
                  <img src={equipment3} />
                </div>
                <h1 className="service-card-title">Mobile Cranes</h1>
                <p
                  className="service-card-description"
                  style={{ color: "#9333EA" }}
                >
                  <CountUp
                    start={0}
                    end={3}
                    duration={10.5}
                    className="count-service"
                  />
                </p>
                <p className="service-card-description">
                  Tadano 80T, 50T & Terex RT 555{" "}
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="equipment-card">
                <div className="round-4">
                  <img src={equipment4} />
                </div>
                <h1 className="service-card-title">Low Bed Trailers</h1>
                <p
                  className="service-card-description"
                  style={{ color: "#EA580C", fontSize: "22px" }}
                >
                  <CountUp
                    start={0}
                    end={6}
                    duration={10.5}
                    className="count-service"
                  />
                </p>
                <p className="service-card-description">
                  {" "}
                  Heavy equipment transportation
                </p>
              </div>
            </Col>
          </Row>
        </div>
        <Row style={{ margin: "20px", width: "96%" }}>
          <Col md={3}>
            <div className="equipment-card">
              <div className="round-5">
                <img src={equipment5} />
              </div>
              <h1 className="service-card-title">Welding Machines</h1>
              <p
                className="service-card-description"
                style={{ color: "#DC2626" }}
              >
                <CountUp
                  start={0}
                  end={10}
                  duration={10.5}
                  className="count-service"
                />
              </p>
              <p className="service-card-description">
                {" "}
                Professional welding equipment
              </p>
            </div>
          </Col>
          <Col md={3}>
            <div className="equipment-card">
              <div className="round-6">
                <img src={equipment6} />
              </div>
              <h1 className="service-card-title">Generators</h1>
              <p
                className="service-card-description"
                style={{ color: "#CA8A04" }}
              >
                <CountUp
                  start={0}
                  end={4}
                  duration={10.5}
                  className="count-service"
                />
              </p>
              <p className="service-card-description">
                {" "}
                Power generation equipment
              </p>
            </div>
          </Col>
          <Col md={3}>
            <div className="equipment-card">
              <div className="round-7">
                <img src={equipment7} />
              </div>
              <h1 className="service-card-title">Workshop Tools</h1>
              <p
                className="service-card-description"
                style={{ color: "#4F46E5" }}
              >
                {/* <CountUp start={0} end={25} duration={2} className="count-service"/>  */}
                <h3>
                  <CountUp
                    start={0}
                    end={25}
                    duration={10.5}
                    className="count-service"
                  />
                  +
                </h3>
              </p>
              <p className="service-card-description">
                Precision machining tools
              </p>
            </div>
          </Col>
          <Col md={3}>
            <div className="equipment-card">
              <div className="round-8">
                <img src={equipment8} />
              </div>
              <h1 className="service-card-title">Light Vehicles</h1>
              <p
                className="service-card-description"
                style={{ color: "#DB2777" }}
              >
                <CountUp
                  start={0}
                  end={12}
                  duration={10.5}
                  className="count-service"
                />
              </p>
              <p className="service-card-description">
                {" "}
                Staff transportation fleet
              </p>
            </div>
          </Col>
        </Row>
      </div>
      <div className="contact-us-main-container">
        <h1 className="contact-us-heading">Let's Build the Future Together</h1>
        <p className="contact-us-content">
          Ready to start your next project? Partner with TAUC for engineering
          excellence and construction expertise you can trust.
        </p>
        <Link to="/contact" onClick={scrollToTop} className="buttonStyleContact" style={{ color: "#1E3A8A" , textDecoration:"none"}}>
                  Contact Us Today <img src={BlueRightArrow} alt="blue-right-arrow" className="blue-right-arrow" />
                </Link>

        {/* <button className="contact-us-button">Contact Us Today </button> */}
      </div>
    </>
  );
};
export default Servies;
